import './SkipToContent.css'

function SkipToContent() {
  return (
    <a href="#main-content" className="skip-to-content">
      Skip to content
    </a>
  )
}

export default SkipToContent
